import { useState } from "react";

import { useTranslation } from "react-i18next";

import {
    DeleteOutlineIcon,
    FileDownloadIcon
} from "@dotnet/telematics-design-system";

import {
    downloadFile,
    ENDPOINTS,
    GetDisabledTextOptions,
    useApi
} from "shared";

import { hasLicenseExpired } from "../../../TableDetails/LicenseDetails/functions";
import { useDialog } from "../../ActionBar/hooks";
import { LICENSE_ACTIONS } from "../../types";
import { TITLES } from "../constants";

const useOfflineLicenseInlineActions = () => {
    const { t } = useTranslation();
    const { isOpenDialog, closeDialog, openDialog } = useDialog();
    const { getData, handleResponse } = useApi();

    const [rowData, setRowData] = useState(null);

    const openDeleteLicenseDialog = (data: any) => {
        setRowData(data);
        openDialog(LICENSE_ACTIONS.DeleteOfflineLicense);
    };

    const inlineActions = [
        {
            title: TITLES.DownloadOfflineLicense,
            hasLoader: true,
            icon: FileDownloadIcon,
            getDisabledText: ({ data }: GetDisabledTextOptions) =>
                hasLicenseExpired(data.expires_at)
                    ? t(`General##license has expired`)
                    : undefined,
            clickAction: (data: any, removeLoading: () => void) =>
                downloadFile({
                    id: data.id,
                    getData,
                    handleResponse,
                    customEndpoint: `${ENDPOINTS.OfflineLicenses}/${data.id}/download`,
                    removeLoading
                })
        },
        {
            title: TITLES.DeleteOfflineLicense,
            icon: DeleteOutlineIcon,
            clickAction: (data: any) => openDeleteLicenseDialog(data)
        }
    ];

    return {
        inlineActions,
        rowData,
        isOpen: isOpenDialog[LICENSE_ACTIONS.DeleteOfflineLicense],
        closeDialog: () => closeDialog(LICENSE_ACTIONS.DeleteOfflineLicense)
    };
};

export { useOfflineLicenseInlineActions };
